export const ApiRoutes = {
    DBAppSettings: 'api/db-app-settings',
    MasterSystemAdminSupportEmail: 'api/master-system-admin-support-email',
    Lookup: 'api/lookup/',
    CaseFileModelLookup: 'api/case-file-model/{caseFileModelId}/lookup/{lookupType}',
    LookupEntityType: 'api/lookup/entity/{entityTypeId}/lookup-type/{lookupType}',
    Organization: 'api/organization',
    OrganizationDetails: 'api/organization/{id}',
    AssociatedOrganizations: 'api/associated-organization/{id}',
    OrganizationsInZone: 'api/organizations-in-zone',
    OrganizationSettings: 'api/organization-settings',
    OrganizationsByCaseFileModel: 'api/organizations-by-case-file-model/{caseFileModelId}',
    UserInvitation: 'api/user/invitation',
    GetUserInvitation: 'api/user/getInvitation',
    UserInvitationDetails: 'api/user/invitation/{id}',
    User: 'api/user',
    UsersInZone: 'api/zone-users',
    UserByRoleRight: 'api/user-by-role-right',
    Login: 'api/account/login',
    Logout: 'api/account/logout',
    UserDetails: 'api/user/{id}',
    LoggedInUserDetails: 'api/login/user',
    AccountRecover: 'api/account/recover',
    AcceptTermsOfService: 'api/account/terms/accept/{id}/{userAgreementContentGuid}',
    ResetPassword: 'api/account/reset',
    Assertiondescriptor: 'api/assertion-descriptor',
    AssertionDescriptors: 'api/assertion-descriptors',
    AssertionDescriptorDetails: 'api/assertion-descriptor/{id}',
    Cases: 'api/cases',
    Case: 'api/case',
    CaseFileModel: 'api/case-file-model',
    //// TODO: DJS Fix this!
    SaveCaseFileDefenseCounsels: 'api/casedefensecounsel/{id}',
    CaseDetails: 'api/case/{id}',
    CaseAuditLogs: 'api/caseauditlog/{id}',
    CasePriority: 'api/case/{id}/priority/{priority}',
    CaseTitle: 'api/case-title/{id}',
    MasterTasks: 'api/master-task',
    CaseTaskNew:
        'api/case/{id}/case-plan/{casePlanId}/task?master-task-id={masterTaskId}&loe={levelOfEffortId}',
    CasePlan: 'api/case-plan/{id}?templateId={templateId}&levelOfEffortId={levelOfEffortId}',
    CaseDeadlines: 'api/case/{id}/deadlines',
    CaseTaskDetails: 'api/case/{id}/case-plan/{casePlanId}/task/{taskId}',
    CasePlanTask: 'api/case/{id}/case-plan/{casePlanId}/task',
    CasePlanTaskAssignments: 'api/case/{id}/case-plan/{casePlanId}/task-assignment',
    UserZoneProfile: 'api/user-zone-profile',
    UserZoneProfiles: 'api/user-zone-profiles',
    UserSetting: 'api/user/setting',

    EntityDocumentsUpload: 'api/entity-document/upload',
    EntityDocumentDelete: 'api/entity-document/delete',
    EntityDocumentDownload: 'api/entity-document/download',
    DocumentTemplate: 'api/document-template/{id}',
    Documents: 'api/my-documents/{pageNumber}/{pageSize}',
    MyDocumentsCount: 'api/my-documents-count',
    MyDocumentsDownload: 'api/my-documents/download/{id}',
    MyDocumentsDelete: 'api/my-documents/{id}',
    ChildDocuments: 'api/collab-report-children/{id}/{entityTypeId}',
    EntityDocumentUpdateMetaData: 'api/document/update-file-meta-data',
    AddExternalDocuments: 'api/entity-document/external',

    Query: 'api/query',
    QueryLegacy: 'api/query-legacy',
    TriggerCreate: 'api/triggers',
    TriggerSearch: 'api/triggers/search',
    TriggerGet: 'api/triggers/{guid}',
    TriggerUpdate: 'api/triggers/{guid}',
    TriggerDelete: 'api/triggers/{guid}',

    Notes: 'api/notes',
    DealNotes: 'api/deal-notes',
    Note: 'api/note',
    NoteDetail: 'api/note/{id}',
    ExportNotes: 'api/export-notes',
    NoteTargets: 'api/note-targets/{noteTypeId}',
    MarkAlertAsReadForUser: 'api/alert/read/{id}',
    UserAlertSummary: 'api/user/alert-summary',
    Deposition: 'api/deposition',
    Depositions: 'api/depositions',
    PackageSettlements: 'api/package-settlements',
    PackageSettlement: 'api/package-settlement',
    PackageSettlementDetail: 'api/package-settlement/{id}',

    // BOARD
    BoardCaseDetails: 'api/board-case-details?type={type}',
    BoardComments: 'api/board-comments',
    ExportBoard: 'api/export-board',

    Reports: 'api/reports/',
    ReportTypeDetail: 'api/report-type/{id}',
    ExportReport: 'api/export-report',
    UnreadQueryExports: 'api/unread-query-exports',

    // ZONE SPECIFIC REPORTS
    TimelineRecap: 'api/timeline-recap',
    TimelineRecapExport: 'api/timeline-recap-export',

    EntityAssertions: 'api/entity-assertions',
    ExecutionPlan: 'api/execution-plan',
    StrategicPlan: 'api/strategic-plan',

    Strategy: 'api/strategy',
    StrategyDetail: 'api/strategy/{id}',

    Projects: 'api/projects',
    ProjectDetail: 'api/project/{id}',

    MeetingAgendaReport: 'api/meeting-agenda',
    ReportDataByReportId: 'api/report-data/{id}/{getLiveData}/{endDate?}',

    Alerts: 'api/alerts',
    Favorites: 'api/favorites',
    FavoriteItem: 'api/favorite/{id}',

    CurrentWeather: 'api/weather/current',

    // EXPERTS
    GetExperts: 'api/experts',
    CreateExpert: 'api/expert',
    GetExpert: 'api/expert/{id}',
    UpdateExpert: 'api/expert',
    DeleteExpert: 'api/expert/{id}',
    ExpertNameExists: 'api/expert/lastName/{lastName}',

    // CASE EXPERTS
    CreateCaseExpert: 'api/case-expert',
    GetCaseExpert: 'api/case-expert/{id}',
    UpdateCaseExpert: 'api/case-expert',
    DeleteCaseExpert: 'api/case-expert/{id}',

    // REPORTS
    CollaborationReportSave: 'api/collaboration-report',
    CollaborationReportComprehensiveSave: '/api/collaboration-report-comprehensive',
    CollaborationReportGet: 'api/collaboration-report/{collaborationReportId}',
    CollaborationReportGetComprehensive:
        'api/collaboration-report-comprehensive/{collaborationReportId}',
    CollaborationReportDelete: 'api/collaboration-report/{collaborationReportId}',
    CollaborationReportGetAll: 'api/collaboration-report/',
    CollaborationReportDataGet: 'api/collaboration-report-data/{collaborationReportId}',
    CollaborationReportUserCreate: 'api/collaboration-report-users/',
    CollaborationReportUsersGetAll: 'api/collaboration-report-users/',
    CollaborationReportHistory: 'api/collaboration-report-history/{collaborationReportId}',
    CollaborationReportGetStatus: 'api/collaboration-report-review-status/{collaborationReportId}',
    StaticReportDataDate: 'api/static-data-date/{documentTypeId}',

    CloseAct: 'api/alert/close-alert-user',

    EntityConversationGetAll: 'api/entity-conversation/{entityGuid}/{entityTypeId}',
    EntityConversationCreate: 'api/entity-conversation/',

    EntityLease: 'api/entity-lease/{entityLeaseId}',
    EntityLeaseIsAvailable: 'api/entity-lease/{entityId}/{entityTypeId}',
    EntityLeaseObtain: 'api/entity-lease-obtain/{entityId}/{entityTypeId}',
    EntityLeaseRenew: 'api/entity-lease-renew/{entityId}/{entityTypeId}',
    EntityLeaseRelease: 'api/entity-lease-release/{entityLeaseGuid}',
    EntityLeasePing: 'api/entity-lease-ping/{entityLeaseGuid}',

    SameCaseGet: 'api/same-case/{sameCaseGuid}/{caseFileModelId}',
    SameCasesView: 'api/same-cases/view',
    SameCaseCheck: 'api/same-case/check/{caseGuid}',
    SameCaseAuditLogs: 'api/same-case/caseauditlog/{caseGuid}',

    CaseResolutionSearch: 'api/case-resolution-plans/search',
    CaseResolutionCreate: 'api/case-resolution-plans',
    CaseResolutionGet: 'api/case-resolution-plan/{id}',
    CaseResolutionDraftGet: 'api/case-resolution-draft/{caseResolutionPlanId}',
    CaseResolutionStepUpdate: 'api/case-plan/{id}/step/{step-id}',
    CaseResolutionStepApprove:
        'api/case-resolution-plan/{caseResolutionPlanId}/step/{stepId}/complete',
    CaseResolutionStepReject:
        'api/case-resolution-plan/{caseResolutionPlanId}/step/{stepId}/undo-complete',
    CaseResolutionStepHistory:
        'api/case-resolution-plan/{caseResolutionPlanId}/step/{stepId}/history',
    CaseResolutionStepHistoryAll:
        'api/case-resolution-plan/{caseResolutionPlanId}/planStepHistoryAll',
    CaseResolutionSetPinned: 'api/case-resolution-plan/{id}/favorite',
    CaseResolutionExport: 'api/case-resolution-plans/export',

    CaseManagersByUser: 'api/case-resolution/case-managers',
    PlaintiffFirmsByUser: 'api/case-resolution/plaintiffs-firms/local',
    NationalPlaintiffFirmsByUser: 'api/case-resolution/plaintiffs-firms/national',

    SameCaseSaveAdmin: 'api/admin/same-case/save',
    SameCaseManageAdmin: 'api/admin/same-case/manage',
    SameCaseMatchedCasesSearchAdmin: 'api/admin/same-case/matched-cases-search',
    SameCaseSearchAdmin: 'api/admin/same-case/search',
    SameCaseRejectAdmin: 'api/admin/same-case/reject/{sameCaseGuid}/{caseGuid}',
    SameCaseProcessAllMatchesAdmin: 'api/admin/same-case/process-matches-all',

    SameCasesEasyUpdateGet: 'api/same-cases/easy-update/{sameCaseGuid}',
    SameCasesEasyUpdate: 'api/same-cases/easy-update/{sameCaseGuid}',
    SameCaseAssertionDescriptors: 'api/quad/assertion-descriptors/{sameCaseGuid}',
    SameCaseStaticItems: 'api/quad/case-static-items/{sameCaseGuid}',

    QuadAssertionDescriptorsByAuthorizedZones:
        'api/quad/assertion-descriptors-by-zones/{caseFileModelId}',
    QuadCaseStaticItemsByAuthorizedZones: 'api/quad/case-static-items-by-zones/{caseFileModelId}',

    QuadZoneUsers: 'api/quad/zone-users/{organizationGuid}',
    QuadOrganizationDependenciesByOrganization:
        'api/quad/organization-dependencies/{organizationGuid}',
    QuadTriggerRuleCreate: 'api/quad/trigger-rule/create',

    QuadCreateZoneNote: 'api/quad/zone-note/create',
    QuadZoneNoteTargets: 'api/quad/zone-note/action-targets',
    QuadQuery: 'api/quad/query',
    QuadNotes: 'api/quad/notes',

    GetUserCaseFileModels: 'api/case-file-model/by-user',

    AssessmentThreatScore: 'api/assessment/threat-score/{caseId}',
    AssessmentBestFitCases: 'api/assessment/best-fit-cases/{caseId}',
    AssessmentCaseStatistics: 'api/assessment/case-statistics/{caseId}',
    AssessmentPredictedOutcome: 'api/assessment/predicted-outcome/{caseId}',
    AssessmentHasModel: 'api/assessment/has-model/',

    GetUserAnnouncements: 'api/announcement/user-announcements',
    GetAnnouncement: 'api/announcement/{announcementContentGuid}',
    GetAnnouncements: 'api/announcements',
    GetPublicAnnouncements: 'api/announcements-public',
    AnnouncementUserAcknowledge: 'api/announcement/user-acknowledge/{announcementContentGuid}',
};
